import { LogoHeader } from "@/components/icons/LogoHeader";
import { OnMaintenanceIllustration } from "@/components/icons/OnMaintenanceIllustration";
import { Container, Content, DescriptionWrapper, IllustrationWrapper, Logo, TextAccent, Text, TextWrapper, Title, Delimiter, TextLink, Footer, FooterText, Separator, FooterLink } from "./styles";
import { NotFoundBgLeftIcon } from "@/components/icons/NotFoundBgLeftIcon";
import { NotFoundBgRightIcon } from "@/components/icons/NotFoundBgRightIcon";

export const OnMaintenanceScreen = () => {
  return (
    <Container>
      <Content>
        <Logo href="/">
          <LogoHeader />
        </Logo>
        <IllustrationWrapper>
          <OnMaintenanceIllustration />
        </IllustrationWrapper>
        <TextWrapper>
          <Title>Diese Seite wird derzeit bearbeitet.</Title>
          <TextAccent>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</TextAccent>
        </TextWrapper>
        <DescriptionWrapper>
          <Text sx={{ width: 311 }}>Besuchen Sie in der Zwischenzeit unsere Genossenschaftsseite <TextLink href="https://propileya.at" target="_blank" rel="noopener noreferrer">propileya.at</TextLink></Text>
          <Delimiter />
          <Text sx={{ width: 311 }}>Bei dringenden Fragen kontaktieren Sie uns bitte über <TextLink href="mailto:office@propileya.at">office@propileya.at</TextLink></Text>
        </DescriptionWrapper>
        <TextAccent sx={{ marginTop: '54px', fontWeight: 700 }}>Vielen Dank für Ihr Verständnis.</TextAccent>
        <Footer>
          <FooterText>© 2026 Propileya</FooterText>
          <Separator>&bull;</Separator>
          <FooterLink href="">Privacy Policy</FooterLink>
          <Separator>&bull;</Separator>
          <FooterLink href="">Terms &amp; Conditions</FooterLink>
          <Separator>&bull;</Separator>
          <FooterLink href="">Impressum</FooterLink>
        </Footer>
      </Content>

      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
        <NotFoundBgLeftIcon />
      </div>
      <div style={{ position: 'absolute', bottom: 0, right: 0, top: 36 }}>
        <NotFoundBgRightIcon />
      </div>
    </Container>
  );
};